// Plugins
import i18n from '@/plugins/i18n'

export default function() {
    let reportTypes = [];

    reportTypes.push({
        value: "courses-name-import",
        text: i18n.t("update_student_course_name"),
        permission: "studentcourse_update",
    });

    reportTypes.push({
        value: "bulk-student-slot-update",
        text: i18n.t("bulk_student_slot_update"),
        permission: "studentslot_studentslotexcelimport",
    });

    reportTypes.push({
        value: "student-course",
        text: i18n.t("student_course"),
        permission: "studentcourse_import",
    });
    reportTypes.push({
        value: "payment-plans",
        text: i18n.t("Adding Bulk Due Dates"),
        permission: "paymentplan_excelimport",
    });
    reportTypes.push({
        value: "student-semester-status-update",
        text: i18n.t("student_semester_status_update"),
        permission: "studentsemester_updatestudentsemesterstatus",
    });
    reportTypes.push({
        value: "batch-student-creation",
        text: i18n.t("batch_student_creation"),
        permission: "student_excelimport",
    });

    return reportTypes;
}


